
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
hr {
  border: none;
  height: 1px;
  background: #ccc;
}
</style>
<style scoped>
</style>

<template>
  <Modal
    v-model="modalonlineservice"
    width="800"
    footer-hide
    class-name="vertical-center-modal"
  >
    <p slot="header">
      <Icon type="md-contact" size="20" />
      <span style="line-height: 24px">{{product.operator }}</span>
    </p>
    <Row>
      <i-col span="16">
        <div
          id="onlineservice"
          style="height: 450px;border: 1px solid #ccc; overflow-y: auto"
        >
          <div>
            <p class="remark p-l-5">
              <Icon type="md-contact" />
              <span style="line-height: 24px"
                >{{product.operator}}</span
              >
            </p>
            <p class="p-l-5">您好，请问有什么能帮到您的？</p>
          </div>

          <div v-for="(item, index) in messagehistory" :key="index">
            <p
              class="remark"
              :class="
                message.username === item.username
                  ? 'p-r-5  text-right'
                  : 'p-l-5'
              "
            >
              <Icon type="md-contact" v-if="message.username !== item.username"/>
              <span style="line-height: 24px"
                >{{
                  message.username === item.username ? "" : product.operator
                }}
                {{ item.createTime }}</span
              >
            </p>
            <p
              :class="
                message.username === item.username
                  ? 'p-r-5 text-right'
                  : 'p-l-5'
              "
            >
              {{ item.message }}
            </p>
          </div>
          <div style="height:20px;"></div>
        </div>
        <Input
          search
          enter-button="发送"
          placeholder="Enter something..."
          style="width: 100%"
          v-model="usermessage"
          @on-search="add"
        />
      </i-col>
      <i-col span="8">
        <div style="height: 180px">
          <div class="p-l-10">
            <h3 class="remark">正在咨询</h3>
          </div>
          <div class="p-l-10">
            <Row>
              <i-col span="8" class="remark" v-if="product.productskuName">媒体名称</i-col>
              <i-col span="16" v-if="product.productskuName">{{product.productskuName}}</i-col>

              <i-col span="8" class="remark" v-if="product.formatuseprice">刊例价(元)</i-col>
              <i-col span="16" v-if="product.formatuseprice">{{product.formatuseprice}}</i-col>

              <i-col span="8" v-if="product.resourceName" class="remark">资源编号</i-col>
              <i-col span="16" v-if="product.resourceName">{{product.resourceName}}</i-col>

              <i-col span="8" v-if="product.stationName" class="remark">站点名称</i-col>
              <i-col span="16" v-if="product.stationName">{{product.stationName}}</i-col>

              <i-col span="8" v-if="product.assetNames" class="remark">线路名称</i-col>
              <i-col span="16" v-if="product.assetNames">{{product.assetNames}}</i-col>

              <i-col span="8" v-if="product.minday" class="remark">最低售卖周期</i-col>
              <i-col span="16" v-if="product.minday">{{product.minday?product.minday+'天':'-'}}</i-col>
            </Row>
          </div>
        </div>
        <div class="p-l-10">
          <Tabs size="small">
            <TabPane label="最近咨询">
              <div style="height: 260px; overflow-y: auto">
                <Row>
                  <i-col span="18" style="font-size: 12px">
                    <p>青岛地铁13号线</p>
                    <p>12封灯箱A+级</p>
                    <p>¥ 1,804.00</p>
                  </i-col>
                  <i-col span="6">
                    <Button size="small" style="margin-top: 20px">发送</Button>
                  </i-col>
                  <i-col span="24"><hr /></i-col>
                </Row>
                <Row>
                  <i-col span="18" style="font-size: 12px">
                    <p>青岛地铁13号线</p>
                    <p>12封灯箱S级</p>
                    <p>¥ 3,529.00</p>
                  </i-col>
                  <i-col span="6">
                    <Button size="small" style="margin-top: 20px">发送</Button>
                  </i-col>
                  <i-col span="24"><hr /></i-col>
                </Row>
                <Row>
                  <i-col span="18" style="font-size: 12px">
                    <p>青岛地铁13号线</p>
                    <p>18封灯箱A+级</p>
                    <p>¥ 2,958.00</p>
                  </i-col>
                  <i-col span="6">
                    <Button size="small" style="margin-top: 20px">发送</Button>
                  </i-col>
                  <i-col span="24"><hr /></i-col>
                </Row>
              </div>
            </TabPane>
            <TabPane label="热门咨询">
              <div style="height: 260px; overflow-y: auto">
                <Row>
                  <i-col span="18" style="font-size: 12px">
                     <p>青岛地铁13号线</p>
                    <p>12封灯箱A+级</p>
                    <p>¥ 1,804.00</p>
                  </i-col>
                  <i-col span="6">
                    <Button size="small" style="margin-top: 20px">发送</Button>
                  </i-col>
                  <i-col span="24"><hr /></i-col>
                </Row>

              </div>
            </TabPane>
          </Tabs>
        </div>
      </i-col>
    </Row>
  </Modal>
</template>

<script>
import { getmessagepage } from '@/api/im'
export default {
  props: {
    consultObj: Object
  },
  data () {
    return {
      modalonlineservice: false,

      value1: 0,
      usermessage: '',
      path: 'ws://39.108.122.13/ooh-search/websocket/',
      socket: '',
      message: {
        to: 'adxsaler',
        username: '149514', // Math.round(Math.random() * 2000).toString(),
        message: ''
      },
      messagehistory: [],
      query: {
        pageNumber: 1,
        pageSize: 200
      },
      product: {}
    }
  },
  methods: {
    showModal (data) {
      this.product = data
      this.initScoket()
      this.message.to = data.linkuserName
      this.query.tousername = this.message.to
      this.query.username = this.message.username
      this.initmessagePage()
      this.modalonlineservice = true
    },
    initmessagePage () {
      getmessagepage(this.query).then((res) => {
        this.messagehistory = res.list.sort((a, b) => (a.id - b.id))
        var div = document.getElementById('onlineservice')
        div.scrollTop = div.scrollHeight
      })
    },
    initScoket () {
      if (typeof WebSocket === 'undefined') {
        alert('您的浏览器不支持socket')
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path + this.message.username)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
    },
    open: function () {
      // console.log('socket连接成功')
    },
    error: function () {
      // console.log('连接错误')
    },
    getMessage: function (msg) {
      this.initmessagePage()
      // console.log(msg.data)
    },
    // send: function () {
    //   this.socket.send()
    // },
    close: function () {
      // console.log('socket已经关闭')
    },
    add () {
      if (this.usermessage) {
        this.message.message = this.usermessage
        this.socket.send(JSON.stringify(this.message))
        this.initmessagePage()
        this.usermessage = ''
      }
    }
  },
  watch: {
    modalonlineservice (val) {
      if (!val) {
        this.socket.onclose = this.close
      }
    }
  }
}
</script>
